import Peer, { PeerOptions } from 'peerjs';

// TODO: FIX THIS JUSTIN
const isHttp = window.location.protocol === 'http:';
enum LogLevel {
  Disabled = 0,
  Errors = 1,
  Warnings = 2,
  All = 3,
}

//export const peerjsConfig: PeerOptions = {
//  host: 'peer.tp.games',
//  port: isHttp ? 80 : 443,
//  debug: LogLevel.All,
//};
export const peerjsConfig: PeerOptions = {
  config: {
    iceServers: [
      {
        urls: [
          'stun:stun.cloudflare.com:3478',
          'turn:turn.cloudflare.com:3478?transport=udp',
          'turn:turn.cloudflare.com:3478?transport=tcp',
          'turns:turn.cloudflare.com:5349?transport=tcp',
        ],
        username: 'g0c9ad4ccfaf1c65639c79f30c7131af1b0a41d3d0bd7aa017f58df224473cbf',
        credential: '7b4b2f8967d20faee30fe57ec1afcd054cacf550e35da7866f4ec3a5db9f6768',
      },
    ],
    debug: LogLevel.All,
  },
};

export function createPeer(uuid?: string, onError?: (error: Error) => void) {
  const logFunction: PeerOptions['logFunction'] = (logLevel, ...rest) => {
    if (logLevel !== LogLevel.Errors) return;
    onError?.(new Error('[PeerJS] ' + rest[1]));
  };

  const config: PeerOptions = { ...peerjsConfig, logFunction };
  return uuid ? new Peer(uuid, config) : new Peer(config);
}
